import { render, staticRenderFns } from "./HotItem.vue?vue&type=template&id=3574c80f&scoped=true"
import script from "./HotItem.vue?vue&type=script&lang=js"
export * from "./HotItem.vue?vue&type=script&lang=js"
import style0 from "./HotItem.vue?vue&type=style&index=0&id=3574c80f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3574c80f",
  null
  
)

export default component.exports